import { IColorPickerResult } from "./../../libs/Picker/types";
import { IconTypes } from "./../../libs/Icon";
import {
    AlignmentTypes,
    ContentType,
    IFieldInputData,
    IFieldLabelData,
    NameInput,
    Selected,
    WidthMeasurement,
    ISingleLineText,
    IPassword,
    IName,
    IPhone,
    INumber,
    NumberContentType,
    IDate,
    IStarRating,
    IUrl,
    IAddress,
    AddressInput,
    IEmail,
    ITerms,
    IHeading,
    IScaleRating,
    LabelAlignmentTypes,
    ScaleRatingInputs,
    IMultiLineText,
    ITime,
    IPrice,
    IDescription,
    ICheckbox,
    IMap,
    ICustomHTML,
    IRadio,
    ISignature,
    ITimeZone,
    IDropdown,
    IPaymentPromoCode,
    IPaymentPaymentMethod,
    IFileUpload,
} from "./boomtypes";
import { IField, FieldGroups, FieldTypes } from "./types";
import { IValidateBy, ValidationTypes } from "./validationTypes";
import { ISelectedItems } from "../selected/types";

export interface IFieldInitial extends Partial<IField> {
    iconType: IconTypes;
}

export const fieldInitials: IFieldInitial[] = [
    {
        type: FieldTypes.SINGLE_LINE_TEXT,
        name: "Single line text",
        group: FieldGroups.INPUT,
        iconType: IconTypes.SINGLE_LINE,
        elements: [
            ISelectedItems.LABEL,
            ISelectedItems.INPUT,
            ISelectedItems.PLACEHOLDER,
            ISelectedItems.DEFAULT_VALUE,
        ],
    },
    {
        type: FieldTypes.INPUT_MULTI_LINE_TEXT,
        name: "Multi line text",
        group: FieldGroups.INPUT,
        iconType: IconTypes.MULTI_LINE,
        elements: [
            ISelectedItems.LABEL,
            ISelectedItems.INPUT,
            ISelectedItems.PLACEHOLDER,
            ISelectedItems.DEFAULT_VALUE,
        ],
    },
    {
        type: FieldTypes.NAME,
        name: "Name",
        group: FieldGroups.INPUT,
        iconType: IconTypes.NAME,
        elements: [ISelectedItems.LABEL, ISelectedItems.INPUT, ISelectedItems.PLACEHOLDER],
    },
    {
        type: FieldTypes.ADDRESS,
        name: "Address",
        group: FieldGroups.INPUT,
        iconType: IconTypes.ADDRESS,
        elements: [ISelectedItems.LABEL, ISelectedItems.PLACEHOLDER, ISelectedItems.INPUT, ISelectedItems.INPUTS_ICONS],
    },
    {
        type: FieldTypes.EMAIL,
        name: "Email",
        group: FieldGroups.INPUT,
        iconType: IconTypes.MAIL,
        elements: [
            ISelectedItems.LABEL,
            ISelectedItems.INPUT,
            ISelectedItems.PLACEHOLDER,
            ISelectedItems.DEFAULT_VALUE,
        ],
    },
    {
        type: FieldTypes.PHONE,
        name: "Phone",
        group: FieldGroups.INPUT,
        iconType: IconTypes.PHONE,
        elements: [ISelectedItems.LABEL, ISelectedItems.INPUT, ISelectedItems.PLACEHOLDER, ISelectedItems.INPUTS_ICONS],
    },
    {
        type: FieldTypes.NUMBER,
        name: "Number",
        group: FieldGroups.INPUT,
        iconType: IconTypes.NUMBER,
        elements: [
            ISelectedItems.LABEL,
            ISelectedItems.INPUT,
            ISelectedItems.PLACEHOLDER,
            ISelectedItems.DEFAULT_VALUE,
            ISelectedItems.INPUTS_ICONS,
        ],
    },
    {
        type: FieldTypes.URL,
        name: "URL",
        group: FieldGroups.INPUT,
        iconType: IconTypes.LINK,
        elements: [ISelectedItems.LABEL, ISelectedItems.INPUT, ISelectedItems.PLACEHOLDER],
    },
    {
        type: FieldTypes.PASSWORD,
        name: "Password",
        group: FieldGroups.INPUT,
        iconType: IconTypes.PASSWORD,
        elements: [ISelectedItems.LABEL, ISelectedItems.INPUT, ISelectedItems.PLACEHOLDER, ISelectedItems.INPUTS_ICONS],
    },
    {
        type: FieldTypes.PRICE,
        name: "Price",
        group: FieldGroups.INPUT,
        iconType: IconTypes.PRICE_MENU,
        elements: [
            ISelectedItems.LABEL,
            ISelectedItems.INPUT,
            ISelectedItems.PLACEHOLDER,
            ISelectedItems.DEFAULT_VALUE,
            ISelectedItems.CURRENCY,
        ],
    },
    {
        type: FieldTypes.CHECKBOX,
        name: "Checkbox",
        group: FieldGroups.CHOICES,
        iconType: IconTypes.CHECKBOX,
        elements: [ISelectedItems.LABEL, ISelectedItems.CHOICES_LABELS, ISelectedItems.CHOICES_ICONS],
    },
    {
        type: FieldTypes.RADIO,
        name: "Radio",
        group: FieldGroups.CHOICES,
        iconType: IconTypes.RADIO_BUTTON,
        elements: [ISelectedItems.LABEL, ISelectedItems.CHOICES_LABELS, ISelectedItems.CHOICES_ICONS],
    },
    {
        type: FieldTypes.DROPDOWN,
        name: "Dropdown",
        group: FieldGroups.CHOICES,
        iconType: IconTypes.DOWN,
        elements: [ISelectedItems.LABEL, ISelectedItems.INPUT, ISelectedItems.PLACEHOLDER, ISelectedItems.INPUTS_ICONS],
    },
    {
        type: FieldTypes.STAR_RATING,
        name: "Star Rating",
        group: FieldGroups.CHOICES,
        iconType: IconTypes.STAR_RATE,
        elements: [ISelectedItems.LABEL, ISelectedItems.CHOICES],
    },
    {
        type: FieldTypes.SCALE_RATING,
        name: "Scale Rating",
        group: FieldGroups.CHOICES,
        iconType: IconTypes.SCALE,
        elements: [ISelectedItems.LABEL, ISelectedItems.SCALE_RATING_INPUTS, ISelectedItems.SCALE_RATING_CIRCLES],
    },
    {
        type: FieldTypes.TERMS,
        name: "Terms & Conditions",
        group: FieldGroups.CHOICES,
        iconType: IconTypes.TERMS_AND_CONDITIONS,
        elements: [
            ISelectedItems.TERMS_LINK,
            ISelectedItems.TERMS_TEXT,
            ISelectedItems.LABEL,
            ISelectedItems.CHOICES_ICONS,
        ],
    },
    {
        type: FieldTypes.DATE,
        name: "Date",
        group: FieldGroups.DATE_AND_TIME,
        iconType: IconTypes.DATE_MOUNTH,
        elements: [
            ISelectedItems.LABEL,
            ISelectedItems.INPUT,
            ISelectedItems.DEFAULT_VALUE,
            ISelectedItems.PLACEHOLDER,
            ISelectedItems.INPUTS_ICONS,
        ],
    },
    {
        type: FieldTypes.TIME,
        name: "Time",
        group: FieldGroups.DATE_AND_TIME,
        iconType: IconTypes.TIME,
        elements: [
            ISelectedItems.LABEL,
            ISelectedItems.INPUT,
            ISelectedItems.DEFAULT_VALUE,
            ISelectedItems.PLACEHOLDER,
            ISelectedItems.INPUTS_ICONS,
        ],
    },
    {
        type: FieldTypes.MAP,
        name: "Map",
        group: FieldGroups.ADVANCED,
        iconType: IconTypes.MAP,
        elements: [ISelectedItems.LABEL, ISelectedItems.MAP],
    },
    // {
    //     type: FieldTypes.DATE_AND_TIME,
    //     name: "Date & Time",
    //     label: "Date & Time",
    //     placeholder: "Type here...",
    //     group: FieldGroups.DATE_AND_TIME,
    //     iconType: IconTypes.DATE_TIME,
    // },
    {
        type: FieldTypes.TIMEZONE,
        name: "Timezone",
        group: FieldGroups.DATE_AND_TIME,
        iconType: IconTypes.TIMEZONE,
        elements: [
            ISelectedItems.LABEL,
            ISelectedItems.INPUT,
            ISelectedItems.PLACEHOLDER,
            ISelectedItems.DEFAULT_VALUE,
            ISelectedItems.INPUTS_ICONS,
        ],
    },
    {
        type: FieldTypes.CUSTOM_HTML,
        name: "Custom HTML",
        group: FieldGroups.ADVANCED,
        iconType: IconTypes.CUSTOM_HTML,
    },

    {
        type: FieldTypes.DESCRIPTION,
        name: "Description",
        group: FieldGroups.TEXTS,
        iconType: IconTypes.DESCRIPTION,
        elements: [ISelectedItems.PLACEHOLDER],
    },
    {
        type: FieldTypes.HEADEING,
        name: "Heading",
        group: FieldGroups.TEXTS,
        iconType: IconTypes.HEADING,
        elements: [ISelectedItems.PLACEHOLDER],
    },
    {
        type: FieldTypes.FILE_UPLOAD,
        name: "File Upload",
        group: FieldGroups.ADVANCED,
        iconType: IconTypes.UPLOAD,
        elements: [ISelectedItems.LABEL, ISelectedItems.INPUT, ISelectedItems.PLACEHOLDER, ISelectedItems.INPUTS_ICONS],
    },
    {
        type: FieldTypes.SIGNATURE,
        name: "Signature",
        group: FieldGroups.ADVANCED,
        iconType: IconTypes.SIGNATURE,
        elements: [ISelectedItems.LABEL, ISelectedItems.SIGNATURE_TABLE, ISelectedItems.INPUTS_ICONS],
    },
    // {
    //     type: FieldTypes.FILL_IN_THE_BLANK,
    //     name: "Fill in the Blank",
    //     label: "Fill in the Blank",
    //     placeholder: "",
    //     group: FieldGroups.ADVANCED,
    //     iconType: IconTypes.FILL_IN_THE_BLANK,
    // },
    // {
    //     type: FieldTypes.MATRIX,
    //     name: "Matrix",
    //     label: "Matrix",
    //     placeholder: "",
    //     group: FieldGroups.ADVANCED,
    //     iconType: IconTypes.MATRIX,
    // },
    {
        type: FieldTypes.PROMOCODE,
        name: "Promo Code",
        group: FieldGroups.NONE,
        iconType: IconTypes.PROMOCODE,
        elements: [
            ISelectedItems.LABEL,
            ISelectedItems.INPUT,
            ISelectedItems.PLACEHOLDER,
            ISelectedItems.APPLY_BUTTON,
            ISelectedItems.APPLY_BUTTON_TEXT,
        ],
    },
    {
        type: FieldTypes.PAYMENT_METHOD,
        name: "Payment Method",
        group: FieldGroups.NONE,
        iconType: IconTypes.MENU,
        elements: [ISelectedItems.LABEL, ISelectedItems.CHOICES_ICONS, ISelectedItems.CHOICES_LABELS],
    },
];

export interface IFieldBoomformInitials {
    [FieldTypes.SINGLE_LINE_TEXT]: ISingleLineText;
    [FieldTypes.PASSWORD]: IPassword;
    [FieldTypes.NAME]: IName;
    [FieldTypes.PHONE]: IPhone;
    [FieldTypes.NUMBER]: INumber;
    [FieldTypes.DATE]: IDate;
    [FieldTypes.STAR_RATING]: IStarRating;
    [FieldTypes.URL]: IUrl;
    [FieldTypes.ADDRESS]: IAddress;
    [FieldTypes.EMAIL]: IEmail;
    [FieldTypes.TERMS]: ITerms;
    [FieldTypes.SCALE_RATING]: IScaleRating;
    [FieldTypes.HEADEING]: IHeading;
    [FieldTypes.INPUT_MULTI_LINE_TEXT]: IMultiLineText;
    [FieldTypes.TIME]: ITime;
    [FieldTypes.PRICE]: IPrice;
    [FieldTypes.DESCRIPTION]: IDescription;
    [FieldTypes.CHECKBOX]: ICheckbox;
    [FieldTypes.MAP]: IMap;
    [FieldTypes.CUSTOM_HTML]: ICustomHTML;
    [FieldTypes.RADIO]: IRadio;
    [FieldTypes.TIMEZONE]: ITimeZone;
    [FieldTypes.DROPDOWN]: IDropdown;
    [FieldTypes.SIGNATURE]: ISignature;
    [FieldTypes.FILE_UPLOAD]: IFileUpload;
    [FieldTypes.PROMOCODE]: IPaymentPromoCode;
    [FieldTypes.PAYMENT_METHOD]: IPaymentPaymentMethod;
}

const initialFonts = {
    family: "Montserrat",
    weight: "500",
    size: "20",
    isItalic: false,
    isUnderline: false,
    isStrikethrough: false,
};

export const color = (lastModified: IColorPickerResult) => ({
    isStyleVisible: true,
    solid: lastModified.style,
    gradient: null,
    imageUrl: null,
    lastModified,
});

const commonFieldLabelStyles = (value: string): IFieldLabelData => ({
    value,
    hidden: false,
    styles: {
        ...initialFonts,
        alignment: LabelAlignmentTypes.TOP_LEFT,
        length: 0,
        color: color({
            style: "#434e5a",
            type: 0,
            value: {
                alpha: 1,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
            },
        }),
    },
});

export const commonFieldInputStyles = (options?: { [key: string]: any }): IFieldInputData["styles"] => {
    return {
        input: {
            widthPx: options && options.widthPx ? options.widthPx : null,
            widthPercent: options && options.widthPercent ? options.widthPercent : 100,
            height: 44,
            widthMeasurement: options && options.widthMeasurement ? options.widthMeasurement : WidthMeasurement.PERCENT,
            fill: {
                color:
                    options && options?.inputFillColor
                        ? options?.inputFillColor
                        : color({
                              style: "#fff",
                              type: 0,
                              value: {
                                  alpha: 1,
                                  blue: 255,
                                  green: 255,
                                  hue: 0,
                                  red: 255,
                                  saturation: 0,
                                  value: 100,
                              },
                          }),
            },
            border: {
                radius: options && options.borderRadius ? options.borderRadius : 8,
                size: options && options.border?.borderSize ? options.border?.borderSize : 1,
                color:
                    options && options.border?.inputBorderColor
                        ? options.border?.inputBorderColor
                        : color({
                              style: options && options.borderColorStyle ? options.borderColorStyle : "#434e5a33",
                              type: 0,
                              value: {
                                  alpha: 0.2,
                                  blue: 90,
                                  green: 78,
                                  hue: 211,
                                  red: 67,
                                  saturation: 26,
                                  value: 35,
                              },
                          }),
            },
        },
        inputValue: {
            ...initialFonts,
            alignment: options && options.inputValueAlignment ? options.inputValueAlignment : AlignmentTypes.LEFT,
            family: "Montserrat",
            weight: options && options.inputValueWeight ? options.inputValueWeight : "400",
            size: options && options.inputValueSize ? options.inputValueSize : "16",
            color:
                options && options.inputValueColor
                    ? options && options.inputValueColor
                    : color({
                          style: "#434E5A",
                          type: 0,
                          value: {
                              alpha: 0.6,
                              blue: 90,
                              green: 78,
                              hue: 0,
                              red: 67,
                              saturation: 0,
                              value: 97,
                          },
                      }),
        },
    };
};

export const commonFieldInput = (
    placeholder: string = "Placeholder",
    options?: { [key: string]: any },
    defaultText: string = "Default Text",
): IFieldInputData => ({
    data: {
        contentType: ContentType.PLACEHOLDER,
        defaultText,
        placeholder,
    },
    styles: commonFieldInputStyles(options),
});

export const fieldBoomformInitials: IFieldBoomformInitials = {
    [FieldTypes.SINGLE_LINE_TEXT]: {
        label: commonFieldLabelStyles("Type a question"),
        input: commonFieldInput(),
        isRequired: {
            value: false,
            message: "",
        },
        tooltip: {
            enabled: false,
            text: "",
        },
        validations: {
            [ValidationTypes.LETTERS]: {
                value: false,
                enabled: false,
                message: "",
            },
            [ValidationTypes.DIGITS]: {
                value: false,
                enabled: false,
                message: "",
            },
            [ValidationTypes.EMAIL]: {
                value: false,
                enabled: false,
                message: "",
            },
            [ValidationTypes.URL]: {
                value: false,
                enabled: false,
                message: "",
            },
            [ValidationTypes.REGEX]: {
                value: " ",
                enabled: false,
                message: "Write your regex error message.",
            },
            [ValidationTypes.MIN_MAX_STRING_LENGTH]: {
                enabled: false,
                min: 0,
                max: 0,
                validateBy: IValidateBy.LENGTH,
                message: "",
            },
        },
    },
    [FieldTypes.INPUT_MULTI_LINE_TEXT]: {
        label: commonFieldLabelStyles("Type a question"),
        input: commonFieldInput("", {}, "Placeholder"),
        isRequired: {
            value: false,
            message: "",
        },
        isRichText: false,
        tooltip: {
            enabled: false,
            text: "",
        },
        validations: {
            [ValidationTypes.LETTERS]: {
                value: false,
                enabled: false,
                message: "",
            },
            [ValidationTypes.DIGITS]: {
                value: false,
                enabled: false,
                message: "",
            },
            [ValidationTypes.URL]: {
                value: false,
                enabled: false,
                message: "",
            },
            [ValidationTypes.REGEX]: {
                value: " ",
                enabled: false,
                message: "Write your regex error message.",
            },
            [ValidationTypes.EMAIL]: {
                value: false,
                enabled: false,
                message: "",
            },
            [ValidationTypes.MIN_MAX_STRING_LENGTH]: {
                enabled: false,
                min: 0,
                max: 0,
                validateBy: IValidateBy.LENGTH,
                message: "",
            },
        },
    },
    [FieldTypes.NAME]: {
        label: commonFieldLabelStyles("Name"),
        isShowLabel: true,
        isRequired: {
            value: false,
            message: "",
        },
        isMiddleName: true,
        tooltip: {
            enabled: false,
            text: "",
        },
        [NameInput.FIRST]: {
            input: commonFieldInput("First name", { widthPercent: 32.9 }),
            isRequired: {
                value: false,
                message: "",
            },
        },
        [NameInput.MIDDlE]: {
            input: commonFieldInput("Middle Name", { widthPercent: 32.8 }),
            isRequired: {
                value: false,
                message: "",
            },
        },
        [NameInput.LAST]: {
            input: commonFieldInput("Last name", { widthPercent: 32.9 }),
            isRequired: {
                value: false,
                message: "",
            },
        },
        validations: {},
    },
    [FieldTypes.PASSWORD]: {
        label: commonFieldLabelStyles("Password"),
        isShowLabel: true,
        isRequired: {
            value: false,
            message: "",
        },
        tooltip: {
            enabled: false,
            text: "",
        },
        input: {
            data: {
                placeholder: "Enter Password",
            },
            styles: commonFieldInputStyles(),
        },
        validations: {
            [ValidationTypes.LETTERS]: {
                value: false,
                enabled: false,
                message: "",
            },
            [ValidationTypes.REGEX]: {
                value: " ",
                enabled: false,
                message: "Write your regex error message.",
            },
            [ValidationTypes.MIN_MAX_STRING_LENGTH]: {
                min: 0,
                max: 0,
                validateBy: IValidateBy.WORD,
                enabled: false,
                message: "",
            },
            [ValidationTypes.DIGITS]: {
                value: false,
                enabled: false,
                message: "",
            },
        },
        icon: {
            styles: commonFieldInputStyles({
                inputValueSize: "20",
                inputFillColor: color({
                    style: "#434E5A",
                    type: 0,
                    value: {
                        alpha: 1,
                        blue: 255,
                        green: 255,
                        hue: 0,
                        red: 255,
                        saturation: 0,
                        value: 100,
                    },
                }),
                borderColorStyle: "#33bfa1",
            }),
        },
    },
    [FieldTypes.PHONE]: {
        label: commonFieldLabelStyles("Phone"),
        isShowLabel: true,
        isRequired: {
            value: false,
            message: "",
        },
        tooltip: {
            enabled: false,
            text: "",
        },
        defaultValue: "(00)000000",
        input: {
            styles: commonFieldInputStyles(),
        },
        isPrefix: true,
        country: "AM",
        search: "",
        validations: {
            [ValidationTypes.MIN_MAX_STRING_LENGTH]: {
                enabled: false,
                min: 0,
                max: 0,
                validateBy: IValidateBy.LENGTH,
                message: "",
            },
        },
        icon: {
            styles: commonFieldInputStyles({
                inputValueSize: "24",
                inputFillColor: color({
                    style: "#434E5A",
                    type: 0,
                    value: {
                        alpha: 1,
                        blue: 255,
                        green: 255,
                        hue: 0,
                        red: 255,
                        saturation: 0,
                        value: 100,
                    },
                }),
                borderColorStyle: "#33bfa1",
            }),
        },
    },
    [FieldTypes.NUMBER]: {
        label: commonFieldLabelStyles("Number"),
        input: {
            data: {
                contentType: NumberContentType.PLACEHOLDER,
            },
            styles: commonFieldInputStyles(),
        },
        placeholder: "Write number",
        defaultValue: "0",
        isShowLabel: true,
        isRequired: {
            value: false,
            message: "",
        },
        arrows: false,
        tooltip: {
            enabled: false,
            text: "",
        },
        validations: {
            [ValidationTypes.MIN_MAX_QUANTITY]: {
                enabled: false,
                min: 0,
                max: 0,
                validateBy: IValidateBy.LENGTH,
                message: "",
            },
        },
        value: { enabled: false, min: 0, max: 0 },
        icon: {
            styles: commonFieldInputStyles({
                inputValueSize: "20",
                inputFillColor: color({
                    style: "#434E5A",
                    type: 0,
                    value: {
                        alpha: 1,
                        blue: 255,
                        green: 255,
                        hue: 0,
                        red: 255,
                        saturation: 0,
                        value: 100,
                    },
                }),
                borderColorStyle: "#33bfa1",
            }),
        },
    },
    [FieldTypes.DATE]: {
        label: commonFieldLabelStyles("Date"),
        input: {
            data: {
                contentType: ContentType.PLACEHOLDER,
                defaultText: "MM/DD/YYYY",
                placeholder: "MM/DD/YYYY",
            },
            styles: commonFieldInput("Date", { widthPercent: 50, widthMeasurement: WidthMeasurement.PERCENT }).styles,
        },
        isShowLabel: true,
        isRequired: {
            value: false,
            message: "",
        },
        tooltip: {
            enabled: false,
            text: "",
        },
        isActive: false,
        validations: {
            [ValidationTypes.MIN_MAX_DATE]: {
                min: {
                    option: "past",
                    value: "",
                },
                max: {
                    option: "future",
                    value: "",
                },
                enabled: false,
                message: "",
            },
        },
        icon: {
            styles: commonFieldInputStyles({
                inputValueSize: "24",
                inputFillColor: color({
                    style: "#434E5A",
                    type: 0,
                    value: {
                        alpha: 1,
                        blue: 255,
                        green: 255,
                        hue: 0,
                        red: 255,
                        saturation: 0,
                        value: 100,
                    },
                }),
                borderColorStyle: "#33bfa1",
            }),
        },
    },
    [FieldTypes.STAR_RATING]: {
        label: commonFieldLabelStyles("Star Rating"),
        starsCount: 6,
        defaultValue: 4,
        isShowLabel: true,
        isRequired: {
            value: false,
            message: "",
        },
        tooltip: {
            enabled: false,
            text: "",
        },
        validations: [],
        isCircle: true,
        input: commonFieldInput("", {
            inputValueSize: "24",
            inputFillColor: color({
                style: "#434E5A",
                type: 0,
                value: {
                    alpha: 1,
                    blue: 90,
                    green: 78,
                    hue: 0,
                    red: 67,
                    saturation: 0,
                    value: 97,
                },
            }),
            border: {
                borderSize: 1,
                inputBorderColor: color({
                    style: "#434e5a",
                    type: 0,
                    value: {
                        alpha: 1,
                        blue: 90,
                        green: 78,
                        hue: 211,
                        red: 67,
                        saturation: 26,
                        value: 35,
                    },
                }),
            },
        }),
    },
    [FieldTypes.URL]: {
        label: commonFieldLabelStyles("URL"),
        input: commonFieldInput("https://www.website.com"),
        isShowLabel: true,
        isRequired: {
            value: false,
            message: "",
        },
        tooltip: {
            enabled: false,
            text: "",
        },
        validations: {},
    },
    [FieldTypes.ADDRESS]: {
        label: commonFieldLabelStyles("Address"),
        [AddressInput.STREET_ADDRESS]: {
            input: commonFieldInput("Street Address"),
            label: commonFieldLabelStyles("Street Address"),
            isRequired: {
                value: false,
                message: "",
            },
        },
        [AddressInput.STREET_ADDRESS_TWO]: {
            input: commonFieldInput("Street Address 2"),
            label: commonFieldLabelStyles("Street Address 2"),
            isRequired: {
                value: false,
                message: "",
            },
        },
        [AddressInput.CITY]: {
            input: commonFieldInput("City", { widthPercent: 50 }),
            label: commonFieldLabelStyles("City"),
            isRequired: {
                value: false,
                message: "",
            },
        },
        [AddressInput.STATE]: {
            input: commonFieldInput("State", { widthPercent: 50 }),
            label: commonFieldLabelStyles("State"),
            isRequired: {
                value: false,
                message: "",
            },
        },
        [AddressInput.ZIP_CODE]: {
            input: commonFieldInput("Zip Code", { widthPercent: 50 }),
            label: commonFieldLabelStyles("Zip Code"),
            isRequired: {
                value: false,
                message: "",
            },
        },
        [AddressInput.SELECT_COUNTRY]: {
            input: {
                data: {
                    contentType: ContentType.PLACEHOLDER,
                    defaultText: null,
                    placeholder: "Select Country",
                },
                styles: commonFieldInput("Select Country", { widthPercent: 50 }).styles,
            },
            label: commonFieldLabelStyles("Select Country"),
            icon: {
                styles: commonFieldInputStyles({
                    inputValueSize: "20",
                    inputFillColor: color({
                        style: "#434E5A",
                        type: 0,
                        value: {
                            alpha: 1,
                            blue: 255,
                            green: 255,
                            hue: 0,
                            red: 255,
                            saturation: 0,
                            value: 100,
                        },
                    }),
                    borderColorStyle: "#33bfa1",
                }),
            },
            isRequired: {
                value: false,
                message: "",
            },
        },
        order: {
            [AddressInput.STREET_ADDRESS]: true,
            [AddressInput.STREET_ADDRESS_TWO]: true,
            [AddressInput.CITY]: true,
            [AddressInput.STATE]: true,
            [AddressInput.ZIP_CODE]: true,
            [AddressInput.SELECT_COUNTRY]: true,
        },
        isRequired: {
            value: false,
            message: "",
        },
        isShowLabel: true,
        tooltip: {
            enabled: false,
            text: "",
        },
        validations: {
            required: {
                [Selected.All]: false,
                [AddressInput.STREET_ADDRESS]: false,
                [AddressInput.STREET_ADDRESS_TWO]: false,
                [AddressInput.CITY]: false,
                [AddressInput.STATE]: false,
                [AddressInput.ZIP_CODE]: false,
                [AddressInput.SELECT_COUNTRY]: false,
            },
        },
    },
    [FieldTypes.EMAIL]: {
        label: commonFieldLabelStyles("Email"),
        input: commonFieldInput("Example@example.com", {}, "Example@example.com"),
        isShowLabel: true,
        isRequired: {
            value: false,
            message: "",
        },
        tooltip: {
            enabled: false,
            text: "",
        },
        validations: {
            [ValidationTypes.DOMAIN]: {
                value: " ",
                enabled: false,
                message: "",
            },
            [ValidationTypes.REGEX]: {
                value: " ",
                enabled: false,
                message: "Write your regex error message.",
            },
        },
    },
    [FieldTypes.HEADEING]: {
        label: commonFieldLabelStyles("Heading"),
        isRequired: {
            value: false,
            message: "",
        },
        tooltip: {
            enabled: false,
            text: "",
        },
        isActive: true,
        isShowLabel: true,
        text: "Heading",
        validations: [],
        input: {
            styles: {
                input: {},
                inputValue: commonFieldInput(
                    "Left",
                    {
                        inputValueWeight: "600",
                        inputValueSize: "24",
                        inputValueColor: color({
                            style: "#434e5a",
                            type: 0,
                            value: {
                                alpha: 0.6,
                                blue: 90,
                                green: 78,
                                hue: 0,
                                red: 67,
                                saturation: 0,
                                value: 97,
                            },
                        }),
                    },
                    "Left",
                ).styles.inputValue,
            },
        },
    },
    [FieldTypes.SCALE_RATING]: {
        label: commonFieldLabelStyles("Scale Rating"),
        tooltip: {
            enabled: false,
            text: "",
        },
        [ScaleRatingInputs.LEFT_INPUT]: {
            label: "",
            input: commonFieldInput("Left", {}, "Left"),
            enabled: true,
        },
        [ScaleRatingInputs.MIDDLE_INPUT]: {
            label: "",
            input: commonFieldInput("Middle", {}, "Middle"),
            enabled: true,
        },
        [ScaleRatingInputs.RIGHT_INPUT]: {
            label: "",
            input: commonFieldInput("Right", {}, "Right"),
            enabled: true,
        },
        isRequired: {
            value: false,
            message: "",
        },
        defaultValue: null,
        startValue: 0,
        endValue: 10,
        input: commonFieldInput(
            "",
            {
                inputValueSize: "44",
                border: {
                    borderSize: 1,
                    inputBorderColor: color({
                        style: "#1DCFA9",
                        type: 0,
                        value: {
                            alpha: 1,
                            blue: 90,
                            green: 78,
                            hue: 211,
                            red: 67,
                            saturation: 26,
                            value: 35,
                        },
                    }),
                },
                inputFillColor: color({
                    style: "#434E5A99",
                    type: 0,
                    value: {
                        alpha: 1,
                        blue: 90,
                        green: 78,
                        hue: 0,
                        red: 67,
                        saturation: 0,
                        value: 97,
                    },
                }),
            },
            "",
        ),
    },
    [FieldTypes.TERMS]: {
        label: commonFieldLabelStyles("Terms & Conditions"),
        input: commonFieldInput(
            "",
            {
                inputValueColor: color({
                    style: "#434E5A",
                    type: 0,
                    value: {
                        alpha: 0.6,
                        blue: 90,
                        green: 78,
                        hue: 0,
                        red: 67,
                        saturation: 0,
                        value: 97,
                    },
                }),
            },
            "",
        ),
        isChecked: false,
        isRequired: {
            value: false,
            message: "",
        },
        tooltip: {
            enabled: false,
            text: "",
        },
        text: "I agree to the {Terms of Service}",
        url: "www.example.com",
        validations: [],
        icon: {
            styles: commonFieldInputStyles({
                inputValueSize: "17",
                borderColorStyle: "#33bfa1",
                inputFillColor: color({
                    style: "#434E5A",
                    type: 0,
                    value: {
                        alpha: 1,
                        blue: 255,
                        green: 255,
                        hue: 0,
                        red: 255,
                        saturation: 0,
                        value: 100,
                    },
                }),
            }),
        },
    },
    [FieldTypes.PRICE]: {
        label: commonFieldLabelStyles("Price"),
        input: commonFieldInput("Placeholder", { widthPx: 216, widthMeasurement: WidthMeasurement.PX }, ""),
        isRequired: {
            value: false,
            message: "",
        },
        validations: {
            [ValidationTypes.MIN_MAX_QUANTITY]: {
                enabled: false,
                min: 0,
                max: 0,
                validateBy: IValidateBy.LENGTH,
                message: "",
            },
        },
        tooltip: {
            enabled: false,
            text: "",
        },
        value: { enabled: false, min: 0, max: 0 },
        currency: {
            value: "USD",
            input: commonFieldInput("Placeholder", { widthPx: 50, WidthMeasurement: WidthMeasurement.PX }, ""),
        },
    },

    [FieldTypes.MAP]: {
        label: commonFieldLabelStyles("Map"),
        input: commonFieldInput("", { borderColorStyle: "#FFFFFF" }),
        isRequired: {
            value: false,
            message: "",
        },
        center: { lat: 48.85837009999999, lng: 2.2944813 },
        markers: null,
        zoom: 4,
        tooltip: {
            enabled: false,
            text: "",
        },
        validations: [],
    },
    [FieldTypes.CUSTOM_HTML]: {
        label: commonFieldLabelStyles(""),
        input: commonFieldInput(),
        html: '<p style="font-family: `Montserrat`;font-style: normal;font-weight: 400;font-size: 16px;line-height: 20px;display: flex;align-items: center;color: #434E5A;opacity: 0.6; margin: 0">This is Heading</p>  <p style="font-family: `Montserrat`;font-style: normal;font-weight: 400;font-size: 16px;line-height: 20px;display: flex;align-items: center;color: #434E5A;opacity: 0.6; margin: 0">This is a paragraph</p>',
        isRequired: {
            value: false,
            message: "",
        },
        tooltip: { enabled: false, text: "" },
        validations: [],
    },
    [FieldTypes.DESCRIPTION]: {
        label: commonFieldLabelStyles("Description"),
        isRequired: {
            value: false,
            message: "",
        },
        tooltip: {
            enabled: false,
            text: "",
        },
        isActive: true,
        isShowLabel: true,
        html: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
        validations: {},
        input: {
            styles: {
                input: {},
                inputValue: commonFieldInput(
                    "Left",
                    {
                        inputValueWeight: "500",
                        inputValueSize: "16",
                        inputValueColor: color({
                            style: "#434e5a",
                            type: 0,
                            value: {
                                alpha: 0.6,
                                blue: 90,
                                green: 78,
                                hue: 0,
                                red: 67,
                                saturation: 0,
                                value: 97,
                            },
                        }),
                    },
                    "Left",
                ).styles.inputValue,
            },
        },
    },
    [FieldTypes.TIME]: {
        label: commonFieldLabelStyles("Time"),
        input: commonFieldInput("HH:MM ", { widthPx: 126, widthMeasurement: WidthMeasurement.PX }, "12:00 "),
        isRequired: {
            value: false,
            message: "",
        },
        dropdown_input: {
            ...commonFieldInput("", { widthPx: 72, widthMeasurement: WidthMeasurement.PX }, ""),
            icon: {
                styles: commonFieldInputStyles({
                    inputValueSize: "20",
                    borderColorStyle: "#33bfa1",
                    inputFillColor: color({
                        style: "#434E5A",
                        type: 0,
                        value: {
                            alpha: 1,
                            blue: 255,
                            green: 255,
                            hue: 0,
                            red: 255,
                            saturation: 0,
                            value: 100,
                        },
                    }),
                }),
            },
        },
        tooltip: {
            enabled: false,
            text: "",
        },
        validations: {
            [ValidationTypes.MIN_MAX_DATE]: {
                min: {
                    option: "",
                    value: "",
                },
                max: {
                    option: "",
                    value: "",
                },
                enabled: false,
                message: "",
            },
        },
    },
    [FieldTypes.CHECKBOX]: {
        label: commonFieldLabelStyles("Checkbox"),
        input: commonFieldInput("otherId"),
        options: null,
        isRequired: {
            value: false,
            message: "",
        },
        column_quantity: 2,
        tooltip: {
            enabled: false,
            text: "",
        },
        checkedOptions: "",
        validations: {
            [ValidationTypes.MIN_MAX_OPTIONS]: {
                enabled: false,
                min: 0,
                max: 0,
                validateBy: IValidateBy.LENGTH,
                message: "",
            },
        },
        icon: {
            styles: commonFieldInputStyles({
                inputValueSize: "20",
                borderColorStyle: "#33bfa1",
                inputFillColor: color({
                    style: "#434E5A",
                    type: 0,
                    value: {
                        alpha: 1,
                        blue: 255,
                        green: 255,
                        hue: 0,
                        red: 255,
                        saturation: 0,
                        value: 100,
                    },
                }),
            }),
        },
        paymentOptions: {
            enabled: false,
            quantity: { enabled: false, value: 0 },
            custom: { enabled: false, value: [] },
        },
    },
    [FieldTypes.RADIO]: {
        label: commonFieldLabelStyles("Radio"),
        input: commonFieldInput("otherId"),
        isRequired: {
            value: false,
            message: "",
        },
        column_quantity: 2,
        defaultValue: "selectedOptionId",
        options: null,
        tooltip: {
            enabled: false,
            text: "",
        },
        validations: {},
        icon: {
            styles: commonFieldInputStyles({
                inputValueSize: "20",
                borderColorStyle: "#33bfa1",
                borderRadius: 50,
                inputFillColor: color({
                    style: "#434E5A",
                    type: 0,
                    value: {
                        alpha: 1,
                        blue: 255,
                        green: 255,
                        hue: 0,
                        red: 255,
                        saturation: 0,
                        value: 100,
                    },
                }),
            }),
        },
        paymentOptions: {
            enabled: false,
            quantity: { enabled: false, value: 0 },
            custom: { enabled: false, value: [] },
        },
    },
    [FieldTypes.DROPDOWN]: {
        label: commonFieldLabelStyles("Dropdown"),
        input: commonFieldInput("Please Select"),
        isRequired: {
            value: false,
            message: "",
        },
        defaultValue: "selectedOptionId",
        options: null,
        tooltip: {
            enabled: false,
            text: "",
        },
        validations: [],
        icon: {
            styles: commonFieldInputStyles({
                inputValueSize: "20",
                inputFillColor: color({
                    style: "#434E5A",
                    type: 0,
                    value: {
                        alpha: 1,
                        blue: 255,
                        green: 255,
                        hue: 0,
                        red: 255,
                        saturation: 0,
                        value: 100,
                    },
                }),
                borderColorStyle: "#33bfa1",
            }),
        },
        paymentOptions: {
            enabled: false,
            quantity: { enabled: false, value: 0 },
            custom: { enabled: false, value: [] },
        },
    },
    [FieldTypes.SIGNATURE]: {
        label: commonFieldLabelStyles("Signature"),
        input: commonFieldInput(""),
        isRequired: {
            value: false,
            message: "",
        },
        tooltip: {
            enabled: false,
            text: "",
        },
        showLine: false,
        validations: {},
        icon: {
            styles: commonFieldInputStyles({
                inputValueSize: "24",
                inputFillColor: color({
                    style: "#434E5A",
                    type: 0,
                    value: {
                        alpha: 1,
                        blue: 255,
                        green: 255,
                        hue: 0,
                        red: 255,
                        saturation: 0,
                        value: 100,
                    },
                }),
                borderColorStyle: "#33bfa1",
            }),
        },
    },
    [FieldTypes.FILE_UPLOAD]: {
        label: commonFieldLabelStyles("File Upload"),
        input: commonFieldInput(
            "",
            {
                inputValueSize: "20",
                inputValueAlignment: AlignmentTypes.CENTER,
            },
            "",
        ),
        isRequired: {
            value: false,
            message: "",
        },
        tooltip: {
            enabled: false,
            text: "",
        },
        isMultiple: false,
        extensions: "",
        validations: {
            [ValidationTypes.MIN_MAX_SIZE]: {
                enabled: false,
                sizeType: "",
                min: 0,
                max: 0,
                validateBy: IValidateBy.SIZE,
                message: "",
            },
            [ValidationTypes.FILE_TYPE_FORMAT]: {
                enabled: false,
                types: [],
                formats: [],
                fileTypeFormat: "",
                validateBy: IValidateBy.TYPE_FORMAT,
                message: "",
            },
        },
        icon: {
            styles: commonFieldInputStyles({
                inputValueSize: "24",
                inputFillColor: color({
                    style: "#434E5A",
                    type: 0,
                    value: {
                        alpha: 1,
                        blue: 255,
                        green: 255,
                        hue: 0,
                        red: 255,
                        saturation: 0,
                        value: 100,
                    },
                }),
                borderColorStyle: "#33bfa1",
            }),
        },
    },
    [FieldTypes.TIMEZONE]: {
        label: commonFieldLabelStyles("Timezone"),
        input: commonFieldInput("Timezone", { widthPercent: 50, widthMeasurement: WidthMeasurement.PERCENT }, ""),
        isRequired: {
            value: false,
            message: "",
        },
        byIpLocation: false,
        defaultValue: "",
        tooltip: {
            enabled: false,
            text: "",
        },
        validations: [],
        icon: {
            styles: commonFieldInputStyles({
                inputValueSize: "24",
                inputFillColor: color({
                    style: "#434E5A",
                    type: 0,
                    value: {
                        alpha: 1,
                        blue: 255,
                        green: 255,
                        hue: 0,
                        red: 255,
                        saturation: 0,
                        value: 100,
                    },
                }),
                borderColorStyle: "#33bfa1",
            }),
        },
    },
    [FieldTypes.PROMOCODE]: {
        label: commonFieldLabelStyles("Promo Code"),
        input: commonFieldInput(""),
        tooltip: {
            enabled: false,
            text: "",
        },
        isRequired: {
            message: "",
            value: false,
        },
        defaultText: "",
        placeholder: "Enter a Promo Code",
        button: {
            enabled: true,
            defaultText: "Apply",
            styles: commonFieldInputStyles({
                widthPx: 67,
                widthMeasurement: WidthMeasurement.PX,
                border: {
                    borderSize: "0",
                },
                inputFillColor: color({
                    style: "#1DCFA9",
                    type: 0,
                    value: {
                        alpha: 0.6,
                        blue: 90,
                        green: 78,
                        hue: 0,
                        red: 67,
                        saturation: 0,
                        value: 97,
                    },
                }),
                inputValueColor: color({
                    style: "#F8F8F8",
                    type: 0,
                    value: {
                        alpha: 0.6,
                        blue: 90,
                        green: 78,
                        hue: 0,
                        red: 67,
                        saturation: 0,
                        value: 97,
                    },
                }),
            }),
        },
        icon: {
            styles: commonFieldInputStyles({
                inputValueSize: "20",
                borderColorStyle: "#33bfa1",
                borderRadius: 50,
                inputFillColor: color({
                    style: "#434E5A",
                    type: 0,
                    value: {
                        alpha: 1,
                        blue: 255,
                        green: 255,
                        hue: 0,
                        red: 255,
                        saturation: 0,
                        value: 100,
                    },
                }),
            }),
        },
    },
    [FieldTypes.PAYMENT_METHOD]: {
        label: commonFieldLabelStyles("Payment Method"),
        placeholder: "",
        input: commonFieldInput(),
        isRequired: {
            message: "",
            value: true,
        },
        tooltip: {
            enabled: false,
            text: "",
        },
        icon: {
            styles: commonFieldInputStyles({
                inputValueSize: "20",
                borderColorStyle: "#33bfa1",
                borderRadius: 50,
                inputFillColor: color({
                    style: "#434E5A",
                    type: 0,
                    value: {
                        alpha: 1,
                        blue: 255,
                        green: 255,
                        hue: 0,
                        red: 255,
                        saturation: 0,
                        value: 100,
                    },
                }),
            }),
        },
    },
};
